var map = {
	"./app4legalTitle.png": 9239,
	"./app4legallogo.png": 9212,
	"./app4legalmsteams.png": 9419,
	"./contractdetails.png": 8387,
	"./critical.png": 6840,
	"./hearingdetails.png": 1225,
	"./high.png": 671,
	"./lexzur-icon-white.png": 1123,
	"./lexzur-icon.png": 8067,
	"./litigationdetails.png": 7383,
	"./logo.png": 8374,
	"./low.png": 9381,
	"./matterdetails.png": 7444,
	"./medium.png": 3766,
	"./setguest.png": 360,
	"./teamsconnect-logo.png": 2255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;